// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__k+jW6","row":"styles_row__4Ag6V","col":"styles_col__YqSHm","title":"styles_title__dnl9C","data":"styles_data__89J0K","coin":"styles_coin__LFsyK"};